<style lang="stylus" scope>
    .topbar
        .topbar-menubox
            position relative
            height 0
            z-index 1
            .menubox-menu
                display flex
                position absolute
                list-style none
                --tLeft 0
                --tWidth 0
                &::after
                    content ''
                    position absolute
                    height 100%
                    width calc(var(--tWidth, 0) * 1px)
                    left calc(var(--tLeft, 0) * 1px)
                    border-bottom 2px solid var(--themeColor)
                    transition left .2s linear, width .2s linear
                li
                    position relative
                    max-width 120px
                    height 30px
                    color rgba(0, 0, 0, 0.6)
                    font-size 14px
                    text-align center
                    line-height 30px
                    cursor pointer
                    &:not(:last-child)
                        margin-right 36px
                    p
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                    &:hover,&.active
                        >p
                            color var(--themeColor)
    @media screen and (max-width: 751px)
        .topbar
            .topbar-menubox
                .menubox-menu
                    li
                        color #000
                        &:not(:last-child)
                            margin-right 0
                        &:after
                            display none
</style>

<template>
    <div class="topbar">
        <div class="topbar-menubox">
            <ul ref="menu" class="menubox-menu">
                <li :class="{ active: menuID == item.id }" v-for="item in menuList" :key="item.id" @click="clickMenu($event, item.id)">
                    <p>{{ item.label }}</p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "topbar",
        data() {
            return {
                menuIndex: 0,
                menuID: 0,
            };
        },
        computed: {
            isViewer() {
                return this.$store.state.userInfo.user_id != this.$store.state.userPage.viewerID;
            },
            menuList() {
                let menuList = [
                    {
                        id: 0,
                        label: `${this.$t("works")} ${this.worksTotal}`,
                        type: "works",
                    },
                    {
                        id: 1,
                        label: `${this.$t("collect")} ${this.collectTotal}`,
                        type: "collect",
                    },
                    {
                        id: 2,
                        label: `${this.$t("like")} ${this.likeTotal}`,
                        type: "like",
                    },
                    {
                        id: 3,
                        label: `${this.$t("following")}`,
                        type: "follow",
                    },
                ];
                if (this.isViewer) {
                    menuList.splice(2, 1);
                }
                return menuList;
            },
            worksTotal() {
                return this.$store.state.userPage.worksTotal;
            },
            collectTotal() {
                return this.$store.state.userPage.collectTotal;
            },
            likeTotal() {
                return this.$store.state.userPage.likeWorks.length;
            },
        },
        components: {},
        props: {},
        methods: {
            clickMenu(e, id) {
                if (!this.$validateLogin()) {
                    this.$store.commit("toTplCenter", {
                        name: "showUserWorks",
                        data: false,
                    });
                    return;
                }
                let pDom = this.$refs.menu;
                pDom.style.setProperty("--tWidth", e.target.parentNode.clientWidth);
                pDom.style.setProperty("--tLeft", e.target.parentNode.offsetLeft);
                this.menuID = id;
                for (let i = 0; i < this.menuList.length; i++) {
                    if (this.menuList[i]["id"] == id) {
                        this.menuIndex = i;
                        break;
                    }
                }

                this.$emit("toMenu", this.menuID);
            },
            toMenu(index) {
                let pDom = this.$refs.menu;
                let w = pDom.children[index].getBoundingClientRect()["width"];
                let l = pDom.children[index].getBoundingClientRect()["x"] - pDom.getBoundingClientRect()["x"];
                pDom.style.setProperty("--tLeft", "" + l);
                pDom.style.setProperty("--tWidth", "" + w);
                this.menuID = this.menuList[index]["id"];
                this.menuIndex = index;

                this.$emit("toMenu", this.menuID);
                this.$store.commit("userPage/setState", {
                    type: "menuIndex",
                    data: index,
                });
            },
        },
        mounted() {
            let activedTab = this.$store.state.tplCenter.activedTab || 0;
            this.toMenu(activedTab);
        },
    };
</script>
<i18n>
{
  "zh": {
    "works": "作品",
    "following": "关注",
    "like": "点赞",
    "collect": "收藏"
  },
  "en": {
    "works": "Works",
    "following": "Following",
    "like": "Likes",
    "collect": "Collect"
  },
  "kr": {
    "works": "작업물",
    "following": "팔로우",
    "like": "처럼",
    "collect": "즐겨찾기"
  },
  "tw": {
    "works": "作品",
    "following": "關注",
    "like": "點讚",
    "collect": "收藏"
  },
  "jp": {
    "works": "作品",
    "following": "フォロー",
    "like": "いいね",
    "collect": "お気に入り"
  },
  "id": {
    "works": "Karya",
    "following": "Mengikuti",
    "like": "Suka",
    "collect": "Kumpulkan"
  }
}
</i18n>
